import { computed, reactive, ref, inject } from "vue"
import Timer from "../TimerHelper"
import useObserver from "./useObserver"
import RegisterApi from "@/module/Register/service/RegisterApi"
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';
export const useOtpFlow = function (config = {}) {
    const events = useObserver()
    // use for config channel
    const options = ref({
        expiresIn: 60,
        ...config
    })
    const timer = ref(new Timer())

    const states = reactive({
        code: "",
        refCode: "",
        idCard: "",
        // control ui
        timeRemaining: "",
        running: false,
        expired: false,
        invalidOtp: false
    })
    const modalStore = inject("ModalStore")
    const { loadingModal } = useLoadingModal(modalStore)

    const isRequestable = computed(() => {
        if (states.expired || states.invalidOtp) {
            return true
        }
        return false
    })

    //#region methods
    const runTimer = function () {
        clearTimer()
        events.emit("timer.start")
        timer.value.initialTimer(options.value.expiresIn);

        states.running = true

        timer.value.runTimer((display) => {
            states.timeRemaining = display;
        }, () => {
            states.running = false
            states.expired = true;
            events.emit("timer.expired")
        });
    }

    const clearTimer = function () {
        if (timer.value.interval) {
            timer.value.stopTimer();
            timer.value.resetTimer();
        }
    }

    const resetFlow = function () {
        states.code = ""
        states.refCode = ""
        states.timeRemaining = ""
        states.running = false
        states.expired = false
        states.invalidOtp = false

        if (options.value.inputCode != null) {
            // console.log(options.value.inputCode)
            options.value.inputCode.clearValue()
        }
    }
    /**
     * 
     * @param {*} mobileNo 
     * @param {*} channel
     */
    const requestOtp = function (info, lineId) {
        events.emit("otp.request.start")
        console.log(options.value)
        console.log("request otp ", info, lineId)
        resetFlow()
        registerRequestOtp(info, lineId)
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
                events.emit("otp.request.end")
                runTimer()
            }, 250);
        })
    }
    const registerRequestOtp = function (info, lineId) {
        loadingModal.show()
        return new Promise((resolve) => {
            RegisterApi.apiRequestOtp(info, 'authen', lineId).subscribe({
                next: (data) => {
                    console.log(data.refcode);
                    states.refCode = data.refcode
                    states.idCard = info.idCard
                    resolve(data.refcode);
                    loadingModal.hide()
                },
                error: (err) => {
                    console.log(err);
                },
            })
        });
    }
    const validateOtp = function (code) {
        loadingModal.show()
        return new Promise((resolve) => {
            RegisterApi.apiRegisterSms(code, states).subscribe({
                next: (data) => {
                    console.log(data);
                    resolve(data);
                    loadingModal.hide()
                },
                error: (err) => {
                    console.log(err);
                    states.invalidOtp = true
                    states.expired = false
                    states.running = false
                    clearTimer()
                    loadingModal.hide()
                },
            })
            // setTimeout(() => {
            //     let result = false
            //     if (!result) {
            //         clearTimer()
            //         states.invalidOtp = true
            //         states.expired = false
            //         states.running = false
            //     }
            //     resolve(result)
            // }, 250);
        })
    }
    //#endregion methods

    return {
        states,
        events,
        isRequestable,
        requestOtp,
        validateOtp,
        //#region timer function
        runTimer,
        clearTimer,
        //#endregion timer function
    }
}

export default useOtpFlow